/* X-All footer behaviour. Progressive: the link columns are <details open>, so
   with no JavaScript every link is visible and crawlable at every width. This
   only syncs them to the breakpoint — closed on phones, open above — and keeps
   desktop summaries out of the tab order, since the stylesheet already makes
   them inert for pointers (pointer-events: none) and a keyboard-only collapse
   would otherwise be reachable where pointer users have no equivalent. */
class XallFooter extends HTMLElement {
  connectedCallback() {
    this.cols = Array.from(this.querySelectorAll('details.x-col'));
    if (!this.cols.length) return;
    this.mq = window.matchMedia('(max-width: 820px)');
    this.sync = this.sync.bind(this);
    this.sync();
    this.mq.addEventListener('change', this.sync);
  }

  disconnectedCallback() {
    if (this.mq) this.mq.removeEventListener('change', this.sync);
  }

  sync() {
    const phone = this.mq.matches;
    this.cols.forEach((col) => {
      col.open = !phone;
      const summary = col.querySelector('summary');
      if (summary) summary.tabIndex = phone ? 0 : -1;
    });
  }
}

if (!customElements.get('xall-footer')) customElements.define('xall-footer', XallFooter);
